var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "xv-if": "LOGGED_IN && false",
      "id": "page"
    }
  }, [_c('v-overlay', {
    attrs: {
      "value": _vm.loading
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64"
    }
  })], 1), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-subtitle-2 secondary--text"
  }, [_vm._v("Locations")])])], 1), _c('v-row', _vm._l(_vm.locations, function (l) {
    return _c('v-col', {
      key: l.xid,
      staticClass: "col-12 col-sm-6 col-lg-4 col-xl-3"
    }, [_c('Transition', {
      attrs: {
        "name": "v-scale-transition"
      }
    }, [!_vm.loading ? _c('Location', {
      staticClass: "mx-auto fill-height d-flex flex-column",
      attrs: {
        "location": l
      }
    }) : _vm._e()], 1)], 1);
  }), 1), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-subtitle-2 secondary--text"
  }, [_vm._v("Staff")])])], 1), _c('v-row', _vm._l(_vm.staff, function (s) {
    return _c('v-col', {
      key: s.xid,
      staticClass: "col-12 col-sm-6 col-lg-4 col-xl-3"
    }, [_c('Staff', {
      attrs: {
        "staff": s
      }
    })], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }